import { Component, OnInit } from '@angular/core';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';
@Component({
  selector: 'pos-floating-action-button',
  templateUrl: './pos-floating-action-button.component.html',
  styleUrls: ['./pos-floating-action-button.component.sass']
})
export class PosFloatingActionButtonComponent implements OnInit {


  actions: {
    id: string, fn: (() => any),
    icon: string,
    tooltip: string
  }[] = new Array();

  show: boolean = false;
  constructor(private floatingService: PosFloatingActionButtonService) {
    this.floatingService.action.subscribe(s => {
      if (s == "removeItems") {
        this.actions = [];
        this.show = false;
      }
      if (s == "addItems") {
        this.actions = this.floatingService.getActions();
        this.show = this.floatingService.getShow();
      }
    })
  }


  ngOnInit(): void {
    this.actions = this.floatingService.getActions();
    this.show = this.floatingService.getShow();
  }

}
